import {
	initialize as initLocalization,
	addTranslationForLanguage
} from 'react-localize-redux'

export const configLocalization = () => dispatch => {
	dispatch(initLocalization(['en']))
	const english = require('../language-en.json')
	dispatch(addTranslationForLanguage(english, 'en'))
}



// WEBPACK FOOTER //
// ./src/actions/localization.js